module.exports = __webpack_public_path__ + "static/media/washer.6e30b51d.svg";